angular.module('filters')

  .filter('percent', function($filter) {
    return function(decimal, percision) {
      decimal = decimal || 0
      percision = percision || 0
      return $filter('number').call(null, decimal * 100, percision) + '%'
    }
  })
